import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addCustomer: "",
  driver: "",
  pickup: "",
  dropoff: "",
  date: "",
  pd_volume: "",
  pd_height: "",
  pd_depth: "",
  pd_width: "",
  everyNumber: "",
  everyType: "",
  ends: "",
  startDate: "",
  endDate: "",
  selectedWeekdays: [],
};

const packageFormSlice = createSlice({
  name: "packageForm",
  initialState,
  reducers: {
    setPackageForm: (state, action) => {
      return { ...state, ...action.payload };
    },
    resetPackageForm: () => initialState,
  },
});

export const { setPackageForm, resetPackageForm } = packageFormSlice.actions;
export default packageFormSlice.reducer;
